/* gl-landing — behaviour for "The Killer Isn't Alice" landing sections.
   Loaded once per section tag, so everything here guards against re-running. */
(function () {
  if (window.__glLandingLoaded) return;
  window.__glLandingLoaded = true;

  var MARK = 'glInit';

  function each(sel, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (el.dataset[MARK]) return;
      el.dataset[MARK] = '1';
      fn(el);
    });
  }

  /* ---------- video slider ---------- */

  function initVideoSliders() {
    each('[data-gl-video-slider]', function (el) {
      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: el.closest('.review_videos_bottoms').querySelector('.swiper-button-next'),
          prevEl: el.closest('.review_videos_bottoms').querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 3, spaceBetween: 24 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
        },
      });
    });
  }

  function initReviewMarquee() {
    each('[data-gl-review-marquee]', function (el) {
      new Swiper(el, {
        slidesPerView: 'auto',
        loop: true,
        centeredSlides: true,
        spaceBetween: 20,
        speed: 4000,
        allowTouchMove: false,
        loopAddBlankSlides: false,
        loopAdditionalSlides: 7,
        freeMode: true,
        autoplay: { delay: 0, disableOnInteraction: false },
        breakpoints: {
          320: { spaceBetween: 15 },
          768: { spaceBetween: 20 },
        },
      });
    });
  }

  function initReviewCards() {
    each('[data-gl-review-cards]', function (el) {
      new Swiper(el, {
        slidesPerView: 3,
        spaceBetween: 20,
        allowTouchMove: true,
        breakpoints: {
          200: { slidesPerView: 1.15, spaceBetween: 10 },
          576: { slidesPerView: 2, spaceBetween: 20 },
          1200: { slidesPerView: 3 },
        },
      });
    });
  }

  function withSwiper(fn) {
    if (typeof Swiper !== 'undefined') return fn();
    var tries = 0;
    var timer = setInterval(function () {
      if (typeof Swiper !== 'undefined') {
        clearInterval(timer);
        fn();
      } else if (++tries > 100) {
        clearInterval(timer);
      }
    }, 50);
  }

  /* ---------- click-to-play videos ---------- */

  /* Bind on the slider root, not on each slide: Swiper's loop mode clones the
     slides, and cloneNode copies the glInit marker but not the listeners — so
     per-slide binding leaves every clone dead to taps, which on mobile is most
     of what you can reach. */
  function initVideoToggles() {
    /* Not each(): it stamps one shared marker, and initVideoSliders already
       claims these same roots — whichever ran first would silence the other. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-gl-video-slider]'), function (root) {
      if (root.dataset.glToggles) return;
      root.dataset.glToggles = '1';
      root.addEventListener('click', function (e) {
        var slide = e.target.closest ? e.target.closest('.review_video_slider_items') : null;
        if (!slide || !root.contains(slide)) return;
        var video = slide.querySelector('video');
        if (!video) return;

        if (video.paused) {
          // One at a time, clones included.
          Array.prototype.forEach.call(root.querySelectorAll('video'), function (other) {
            if (other !== video && !other.paused) {
              other.pause();
              markPlaying(other, false);
            }
          });
          var p = video.play();
          if (p && p.catch) p.catch(function () { markPlaying(video, false); });
          markPlaying(video, true);
        } else {
          video.pause();
          markPlaying(video, false);
        }
      });
    });
  }

  function markPlaying(video, playing) {
    var slide = video.closest('.review_video_slider_items');
    if (slide) slide.classList.toggle('is-playing', !!playing);
  }

  /* Muted autoplay is refused on iOS in Low Power Mode and by some data-saver
     modes, which leaves the element parked on its poster. Retry once the video
     is actually on screen; if it still refuses, the poster is the fallback. */
  function initAutoplayVideos() {
    each('video[data-gl-autoplay]', function (video) {
      var tryPlay = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) {
        tryPlay();
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) tryPlay();
          });
        },
        { threshold: 0.25 }
      );
      io.observe(video);
    });
  }

  /* ---------- FAQ accordion ---------- */

  function initFaq() {
    each('[data-gl-faq]', function (root) {
      Array.prototype.forEach.call(root.querySelectorAll('.faq-head'), function (head) {
        var content = head.parentElement.querySelector('.faq-content');
        if (!content) return;

        function toggle() {
          var open = head.classList.toggle('open');
          head.setAttribute('aria-expanded', open ? 'true' : 'false');
          content.classList.toggle('open', open);
          content.style.maxHeight = open ? content.scrollHeight + 40 + 'px' : null;
        }

        head.addEventListener('click', toggle);
        head.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  }

  /* ---------- sticky add-to-cart bar ---------- */

  /* Above 990px Horizon scrolls .page-wrapper rather than the window, so
     reading window.pageYOffset there always returns 0. Measure whichever
     element is actually scrolling. */
  function scrollMetrics() {
    var wrap = document.querySelector('.page-wrapper');
    if (wrap && wrap.scrollHeight > wrap.clientHeight + 1) {
      var style = getComputedStyle(wrap).overflowY;
      if (style === 'auto' || style === 'scroll') {
        return { top: wrap.scrollTop, viewport: wrap.clientHeight, doc: wrap.scrollHeight };
      }
    }
    return {
      top: window.pageYOffset || document.documentElement.scrollTop,
      viewport: window.innerHeight,
      doc: document.documentElement.scrollHeight,
    };
  }

  function initStickyCart() {
    each('[data-gl-sticky-cart]', function (bar) {
      var page = bar.closest('.gl-page');
      if (!page) return;

      var update = function () {
        var m = scrollMetrics();
        page.classList.toggle('gl-sticky-on', m.top > 900 && m.top + m.viewport < m.doc - 100);
      };

      window.addEventListener('scroll', update, { passive: true, capture: true });
      window.addEventListener('resize', update);
      var wrap = document.querySelector('.page-wrapper');
      if (wrap) wrap.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- visitor country flag ---------- */

  function initCountryFlag() {
    var flag = document.getElementById('gl-country-flag');
    if (!flag || flag.dataset[MARK]) return;
    flag.dataset[MARK] = '1';
    fetch('https://ipapi.co/json/')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.country_code) return;
        flag.src = 'https://flagcdn.com/64x48/' + data.country_code.toLowerCase() + '.png';
      })
      .catch(function () {
        flag.remove();
      });
  }

  /* ---------- footer menu accordions (mobile only) ---------- */

  function initFooterMenus() {
    each('.footer-main-sec .footer_title1', function (title) {
      title.addEventListener('click', function () {
        if (window.innerWidth > 767) return;
        var col = title.parentElement;
        var wasOpen = col.classList.contains('active');
        Array.prototype.forEach.call(
          col.parentElement.querySelectorAll('.footer-menu'),
          function (other) {
            other.classList.remove('active');
          }
        );
        col.classList.toggle('active', !wasOpen);
      });
    });
  }

  /* ---------- post-add-to-cart upsell ---------- */

  function initUpsell() {
    var modal = document.querySelector('[data-gl-upsell]');
    if (!modal || modal.dataset[MARK]) return;
    modal.dataset[MARK] = '1';

    var lastFocus = null;

    function open() {
      if (!modal.hidden) return;
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.classList.add('gl-upsell-open');
      var close = modal.querySelector('.gl-upsell__close');
      if (close) close.focus();
    }

    function close() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.documentElement.classList.remove('gl-upsell-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    Array.prototype.forEach.call(modal.querySelectorAll('[data-gl-upsell-close]'), function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    /* Take over the add: the main title and both bonus titles go to the cart in
       a single /cart/add.js call, then we show the confirmation. Intercepting in
       the capture phase stops Horizon's product-form-component from also firing
       its own single-item add. */
    function refreshCartUi() {
      // Best effort: nudge Horizon's cart icon/drawer to re-read the cart.
      try {
        var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        ev.action = 'add';
        document.dispatchEvent(ev);
      } catch (err) {
        /* the count catches up on the next page load */
      }
    }

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        if (!form.closest('.gl-page')) return;

        var variantInput = form.querySelector('input[name="id"]');
        if (!variantInput || !variantInput.value) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        var button = form.querySelector('button[name="add"]');
        if (button) button.setAttribute('aria-busy', 'true');

        var items = [{ id: variantInput.value, quantity: 1 }];
        var giftField = form.querySelector('[data-gl-gift-ids]');
        var gifts = giftField && giftField.value ? giftField.value.split(',') : [];
        gifts.forEach(function (id) {
          id = id.trim();
          if (id) items.push({ id: id, quantity: 1 });
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (button) button.removeAttribute('aria-busy');
            if (data && data.status && data.status >= 400) {
              // Sold out or an unpublished gift — fall back to the plain submit
              // so the shopper still gets the main title.
              form.submit();
              return;
            }
            refreshCartUi();
            open();
          })
          .catch(function () {
            if (button) button.removeAttribute('aria-busy');
            form.submit();
          });
      },
      true
    );
  }

  function boot() {
    withSwiper(function () {
      initVideoSliders();
      initReviewMarquee();
      initReviewCards();
    });
    initVideoToggles();
    initAutoplayVideos();
    initFaq();
    initStickyCart();
    initCountryFlag();
    initFooterMenus();
    initUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-run after a theme-editor section reload.
  document.addEventListener('shopify:section:load', boot);
})();
